import { store } from '@/app/store';
import { selectAllAssets, selectAssetById, useGetAssetsQuery } from '@/features/assets/assetsApi';
import { getSelectedMarketFromUrl } from '@/shared/helpers/marketHelpers';
import { useMemo } from 'react';
import { orderBy } from 'lodash';
import { ASSETS_NAMES } from '@/shared/utils/constants';
import { calculateEuroValue } from '@/shared/helpers/portfolioHelpers';
import { useMarketInfo } from '@/shared/hooks/market';
import { selectAllPortfolioBalances, useGetPortfolioBalancesQuery } from '@/features/balance/balancesApi';
import { useSelector } from 'react-redux';
import { selectIsLoggedIn } from '@/features/oAuth/oAuthSlice';

export const useAssets = (assetId?: string) => {
  return {
    assets: selectAllAssets(store.getState()),
    asset: assetId ? selectAssetById(store.getState(), assetId) : null,
    query: useGetAssetsQuery(undefined, {
      refetchOnMountOrArgChange: true
    })
  };
};

export const useSelectedAssetId = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { marketsInfo } = useMarketInfo();

  const { data: portfolioBalancesData } = useGetPortfolioBalancesQuery(undefined, {
    skip: !isLoggedIn
  });

  const assetsPortfolioBalances = selectAllPortfolioBalances(store.getState());

  const walletBalances = useMemo(
    () => calculateEuroValue(assetsPortfolioBalances, marketsInfo),
    [assetsPortfolioBalances, marketsInfo]
  );

  const sortedWalletBalances = useMemo(
    () =>
      orderBy(
        walletBalances,
        [(asset) => Number(asset.euroValue), (asset) => ASSETS_NAMES[asset.assetId]],
        ['desc', 'asc']
      ),
    [walletBalances]
  );

  if (portfolioBalancesData && getSelectedMarketFromUrl(portfolioBalancesData)) {
    return getSelectedMarketFromUrl(portfolioBalancesData);
  } else {
    return sortedWalletBalances[0]?.assetId;
  }
};
